<script setup>
import { ref, onBeforeMount, computed } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useSitesStore } from "@/stores/sites";
import { useUiStore } from "@/stores/ui";
import useEncryption from "@/utils/helpers/encryption";

const sitesStore = useSitesStore();
const uiStore = useUiStore();
const emit = defineEmits(["refresh", "showPasswordHistory", "removeBackground"]);
const company_id = useCompanyStore().companyId;

const { decryptionPassword, usePasswordVisibility } = useEncryption();
const { passwordInputType, passwordIconClass, togglePassword } = usePasswordVisibility();

let id = ref(null);
let password = ref(null);
let isSubmitted = ref(false);
let siteData = ref(null);
const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);

onBeforeMount(() => {
  if (getModalInfo.value && getModalInfo.value.data_type == "site" && getModalAction.value == "set_site_password") {
    siteData.value = getModalInfo.value;
    id.value = getModalInfo.value.id;
    password.value = getModalInfo.value.sitePasswords[0]?.password
      ? decryptionPassword(getModalInfo.value.sitePasswords[0]?.password).slice(1, -1)
      : null;
  }
});

const resetStoreData = () => {
  uiStore.resetModalStore();
};

const showPasswordHistory = async () => {
  await emit("showPasswordHistory", siteData.value);
};

const onSubmit = () => {
  isSubmitted.value = true;
  const data = { site_id: id.value, password: password.value, company_id };
  sitesStore
    .setSitePassword(data)
    .then(async () => {
      await emit("refresh");
      await resetStoreData();
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};
</script>

<template>
  <DModal v-if="getModalAction === 'set_site_password'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Site Password </template>

    <template #body>
      <div class="mb-3">
        <DInput
          :value="password"
          @input="password = $event.target.value"
          :type="passwordInputType"
          label="Password"
          width="100%"
          maxlength="6"
        />
        <span class="showPassword" @click="togglePassword"><i :class="passwordIconClass"></i></span>
      </div>
      <span class="hint-input flex items-center"><b>Note:</b> You can show password list <button @click="showPasswordHistory()" class="btn btn-text">Here</button></span>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!password || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Update <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
